import React from 'react';
import styles from './content.module.scss';

const TermsContent: React.FC<any> = ({ html }) => {
    return (
        <div className={styles.terms}>
            <div className={styles.title}>
                <h2>
                    <i className="fa fa-gavel" />
                    قوانین و مقررات استفاده از تکست نویس
                </h2>
            </div>
            <div className={styles.body} dangerouslySetInnerHTML={{ __html: html }} />
        </div>
    );
}

export default TermsContent;
